__turbopack_context__.v({
  "auth-guard-spin": "auth-guard-module__2RluVG__auth-guard-spin",
  "brand": "auth-guard-module__2RluVG__brand",
  "copy": "auth-guard-module__2RluVG__copy",
  "panel": "auth-guard-module__2RluVG__panel",
  "screen": "auth-guard-module__2RluVG__screen",
  "spinner": "auth-guard-module__2RluVG__spinner",
});
